import React from "react";
import { Helmet } from "react-helmet-async";
import "./LegalPages.css";

function PrivacyPolicy() {
  return (
    <div className="dor-legal-page">
      <Helmet>
        <title>Privacy Policy | DOR Dress On Rent</title>
        <meta
          name="description"
          content="Read the privacy policy of DOR Dress On Rent and how we handle and protect customer information."
        />
        <link rel="canonical" href="https://www.dordressonrent.com/privacy" />
      </Helmet>

      <div className="dor-legal-container">

        <h1>Privacy Policy</h1>

        <p>
          Dress On Rent values your privacy. This policy explains how we
          collect, use, and protect your information when you visit our website.
        </p>

        <h2>1. Information We Collect</h2>
        <p>
          We may collect personal information such as your name,
          phone number, email address, and inquiry details when
          you contact us or express interest in partnerships.
        </p>

        <h2>2. How We Use Your Information</h2>
        <p>
          Your information may be used to respond to inquiries,
          provide partnership details, improve services,
          and communicate important updates.
        </p>

        <h2>3. Data Protection</h2>
        <p>
          We take appropriate measures to protect your personal
          information and prevent unauthorized access or misuse.
        </p>

        <h2>4. Third-Party Services</h2>
        <p>
          We may use trusted third-party tools for analytics,
          communication, or marketing purposes.
        </p>

        <h2>5. Cookies</h2>
        <p>
          Our website may use cookies to enhance user experience
          and analyze website performance.
        </p>

        <h2>6. Policy Updates</h2>
        <p>
          This privacy policy may be updated periodically.
          Changes will be posted on this page.
        </p>

      </div>

    </div>
  );
}

export default PrivacyPolicy;